import script from "./RubricaTabla.vue?vue&type=script&lang=ts&setup=true"
export * from "./RubricaTabla.vue?vue&type=script&lang=ts&setup=true"

import "./RubricaTabla.vue?vue&type=style&index=0&id=867853ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-867853ba"]])

export default __exports__